module.exports = __webpack_public_path__ + "static/media/hashtag-nft-17.f10426b1.jpg";